<template>
  <vx-card title="基本情報の入力">
    <form>
      <vs-input
        class="w-1/3 mt-5"
        label="氏名"
        v-model="localData.name"
        v-validate="'required|max:32'"
        name="name"
        data-vv-as="氏名"
      />
      <span class="text-danger text-sm" v-show="errors.has('name')">{{
        errors.first("name")
      }}</span>

      <vs-input
        class="w-1/3 mt-5"
        label="氏名(ローマ字)"
        v-model="localData.name_en"
        v-validate="'required|alpha_spaces|max:32'"
        name="name_en"
        data-vv-as="氏名(ローマ字)"
      />
      <span class="text-danger text-sm" v-show="errors.has('name_en')">{{
        errors.first("name_en")
      }}</span>

      <vs-input
        class="w-1/3 mt-5"
        label="Eメール"
        v-model="localData.email_address"
        type="email"
        v-validate="'email'"
        name="email"
        data-vv-as="Eメール"
      />
      <span class="text-danger text-sm" v-show="errors.has('email')">{{
        errors.first("email")
      }}</span>

      <vs-input
        class="w-1/3 mt-5"
        label="電話番号(ハイフンなし)"
        v-model="localData.phone_number"
        v-validate="'numeric|custom_phoneNumber'"
        name="phone_number"
        data-vv-as="電話番号"
      />
      <span class="text-danger text-sm" v-show="errors.has('phone_number')">{{
        errors.first("phone_number")
      }}</span>

      <vs-input 
          class="w-1/3 mt-5"
          label="社員番号"
          v-model="localData.origin_number"
          v-validate="'max: 128'"
          name="origin_number"
          data-vv-as="社員番号"
        />
        <span class="text-danger text-sm" v-show="errors.has('origin_number')">{{
          errors.first("origin_number")
        }}</span>

      <div class="mt-8 flex flex-wrap items-center">
        <vs-button
          type="filled"
          :disabled="!validateForm"
          @click.prevent="submitForm"
          class="mt-5 block"
          >登録する</vs-button
        >
      </div>
    </form>
  </vx-card>
</template>

<script>
import { createNamespacedHelpers } from "vuex";
const { mapActions } = createNamespacedHelpers("enterpriseUserAdd");

export default {
  data() {
    return {
      localData: {
        name: null,
        name_en: null,
        phone_number: null
      }
    };
  },
  computed: {
    validateForm() {
      return !this.errors.any();
    }
  },
  methods: {
    ...mapActions(["addUser"]),
    async submitForm() {
      let result = await this.$validator.validateAll();
      if (result) {
        try {
          let payload = JSON.parse(JSON.stringify(this.localData));
          await this.addUser(payload);
          this.$vs.notify({
            title: this.localData.name + "さんを登録しました",
            color: "success",
            iconPack: "feather",
            icon: "icon-check"
          });
          await this.$router.replace("user-list");
        } catch (e) {
          let msg = "";
          if (e.code === 422) {
            if (e.data[0].target === "phoneNumber") {
              msg = `電話番号に${this.localData.phone_number}は登録できません`;
            }
          } else {
            msg = e.data[0].message;
          }
          this.$vs.notify({
            title: "社員登録に失敗しました",
            text: msg,
            color: "danger",
            iconPack: "feather",
            icon: "icon-x-square",
            fixed: true
          });
        }
      }
    }
  }
};
</script>
